// Free point weather probe via Open-Meteo (no API key). Speed already in knots.
export async function fetchPointWeather(lat, lng) {
  const marineUrl =
    `https://marine-api.open-meteo.com/v1/marine?latitude=${lat}&longitude=${lng}` +
    `&current=wave_height,wind_wave_height,wind_wave_direction,wave_period`;
  const fcUrl =
    `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lng}` +
    `&current=wind_speed_10m,wind_direction_10m,wind_gusts_10m,temperature_2m,cloud_cover_low&wind_speed_unit=kn`;
  const [m, f] = await Promise.allSettled([
    fetch(marineUrl).then((r) => r.json()),
    fetch(fcUrl).then((r) => r.json()),
  ]);
  return {
    marine: m.status === "fulfilled" ? (m.value && m.value.current) || null : null,
    fc: f.status === "fulfilled" ? (f.value && f.value.current) || null : null,
  };
}
